import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "drawer-content note-form" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "fields" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-minus" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-minus" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-minus" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "buttons" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-pencil" }, null, -1)
const _hoisted_18 = ["textContent"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Cancel", -1)
const _hoisted_20 = [
  _hoisted_19
]

import { computed, markRaw, onMounted, reactive } from "vue";
import { useStore } from "vuex";
import useVuelidate from "@vuelidate/core";
import { Actions } from "@/store";
import { Note, noteValidations } from "@/models/note";
import Loading from "@/components/common/Loading.vue";
import Field from "@/components/common/Field.vue";
import { useLoading } from "../common/loading.composable";
import { DrawerMutations } from "@/stores/drawer.store";
import ShortcutForm from "../shortcut/ShortcutForm.vue";
import { Shortcut } from "@/models/shortcut";
import { useEvents, Event } from "@/core/services/events.composable";
import FieldMarkdown from "../common/FieldMarkdown.vue";
import FieldItems from "../common/FieldItems.vue";
import { useRouter } from "vue-router";
import AddNoteForm from "./AddNoteForm.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NoteForm',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const router = useRouter();
const events = useEvents();

const note = reactive<Note>({
  ...store.state.note
});
const notes = computed<Note[]>(() => store.state.notes);
const shortcut = computed<Shortcut>(() => store.state.shortcut);
const shortcuts = computed<Shortcut[]>(() => store.state.shortcuts);

const isNew = computed<boolean>(() => note?.id === -1);

const { loading, setLoading } = useLoading();

onMounted(() => {
  store.dispatch(Actions.GetApplications);
  store.dispatch(Actions.GetNotes);
  store.dispatch(Actions.GetShortcuts);

  if (!store.state.note || store.state.note.id === -1) {
    store.dispatch(Actions.NewNote);
    Object.assign(note, { ...store.state.note });
  }
});

events.on(Event.ShortcutCreated, () => {
  note.shortcut_keys = [...(note.shortcut_keys || []), shortcut.value.id];
});

const $v = useVuelidate(noteValidations, { note });
const emit = __emit;

const submit = async () => {
  $v.value.$touch();
  if (!$v.value.$invalid) {
    setLoading(true);
    await store.dispatch(Actions.StoreNote, note);

    setLoading(false);
    cancel();
  }
};

const cancel = () => {
  emit("close");
  if (note.id === -1) {
    router.push(`/note`);
  } else {
    router.push(`/note/${note.id}`);
  }
};

const addUrl = () => {
  note.urls = [...(note.urls || []), { label: "", url: "" }];
};

const removeUrl = (index: number) => {
  note.urls.splice(index, 1);
};

const addShortcut = () => {
  store.commit(DrawerMutations.OpenDrawer, {
    drawer: markRaw(ShortcutForm),
    data: {
      application: note.application_id,
      shortcuts: shortcuts.value.filter(
        (s) => !(note.shortcut_keys || []).includes(s.id)
      )
    }
  });
};

const removeShortcut = (index: number) => {
  note.shortcut_keys.splice(index, 1);
};

const getShortCut = (id: number): string => {
  return shortcuts.value.find((s) => s.id === id)?.name || "unknown";
};

const addNote = () => {
  store.commit(DrawerMutations.OpenDrawer, {
    drawer: markRaw(AddNoteForm),
    data: {
      notes: notes.value.filter((s) => !(note.chapters || []).includes(s.id))
    }
  });
};

events.on(Event.NoteCreated, (n) => {
  note.chapters = [...(note.chapters || []), n.id];
});

const removeNote = (index: number) => {
  note.chapters.splice(index, 1);
};

const getNote = (id: number): string => {
  return notes.value.find((s) => s.id === id)?.title || "unknown";
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    note
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _withModifiers(submit, ["prevent"]),
          class: _normalizeClass({ submitting: _unref(loading) })
        }, [
          _createElementVNode("h2", {
            textContent: _toDisplayString(isNew.value ? 'Add note' : 'Edit note')
          }, null, 8, _hoisted_2),
          (isNew.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Fill out the details of the note"))
            : (_openBlock(), _createElementBlock("p", _hoisted_4, "Edit the details of the note")),
          _createVNode(Field, {
            label: "Title",
            validation: _unref($v).note.title,
            modelValue: note.title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((note.title) = $event))
          }, null, 8, ["validation", "modelValue"]),
          _createVNode(FieldMarkdown, {
            label: "Description",
            validation: _unref($v).note.description,
            modelValue: note.description,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((note.description) = $event)),
            "upload-path": '/api/upload'
          }, null, 8, ["validation", "modelValue"]),
          _createVNode(FieldItems, {
            label: "Urls",
            onAddItem: addUrl,
            onRemoveItem: removeUrl
          }, {
            default: _withCtx(() => [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(note.urls, (url, index) => {
                  return (_openBlock(), _createElementBlock("li", _hoisted_5, [
                    _createVNode(Field, {
                      placeholder: "Label",
                      class: "block",
                      modelValue: url.label,
                      "onUpdate:modelValue": ($event: any) => ((url.label) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _createVNode(Field, {
                      placeholder: "Url",
                      class: "block",
                      modelValue: url.url,
                      "onUpdate:modelValue": ($event: any) => ((url.url) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn icononly",
                      onClick: ($event: any) => (removeUrl(index))
                    }, _hoisted_8, 8, _hoisted_6)
                  ]))
                }), 256))
              ])
            ]),
            _: 1
          }),
          _createVNode(FieldItems, {
            label: "Shortcuts",
            onAddItem: addShortcut,
            onRemoveItem: removeUrl
          }, {
            default: _withCtx(() => [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(note.shortcut_keys, (shortcut, index) => {
                  return (_openBlock(), _createElementBlock("li", null, [
                    _createTextVNode(_toDisplayString(getShortCut(shortcut)) + " ", 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn icononly",
                      onClick: ($event: any) => (removeShortcut(index))
                    }, _hoisted_11, 8, _hoisted_9)
                  ]))
                }), 256))
              ])
            ]),
            _: 1
          }),
          _createVNode(FieldItems, {
            label: "Chapters",
            onAddItem: addNote
          }, {
            default: _withCtx(() => [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(note.chapters, (n, index) => {
                  return (_openBlock(), _createElementBlock("li", null, [
                    _createTextVNode(_toDisplayString(getNote(n)) + " ", 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn icononly",
                      onClick: ($event: any) => (removeNote(index))
                    }, _hoisted_14, 8, _hoisted_12)
                  ]))
                }), 256))
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              class: "confirm",
              type: "button",
              disabled: _unref(loading),
              onClick: submit
            }, [
              _hoisted_17,
              _createElementVNode("span", {
                class: "text",
                textContent: _toDisplayString(isNew.value ? 'Add' : 'Edit')
              }, null, 8, _hoisted_18)
            ], 8, _hoisted_16),
            _createElementVNode("button", {
              class: "cancel",
              type: "button",
              onClick: cancel
            }, _hoisted_20),
            (_unref(loading))
              ? (_openBlock(), _createBlock(Loading, { key: 0 }))
              : _createCommentVNode("", true)
          ])
        ], 34))
      : _createCommentVNode("", true)
  ]))
}
}

})